(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["couturierista-home"] && !Shopify.designMode) return;
  try {
    
const menuButton=document.querySelector('.cn-menu-button');const menu=document.querySelector('.cn-menu');const closeButton=document.querySelector('.cn-menu-close');const setMenu=open=>{menu.classList.toggle('is-open',open);menu.setAttribute('aria-hidden',String(!open));menuButton.setAttribute('aria-expanded',String(open));};menuButton?.addEventListener('click',()=>setMenu(true));closeButton?.addEventListener('click',()=>setMenu(false));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const sortCollectionColors = root => {
    root.querySelectorAll('.shopify-section--main-collection product-list').forEach(list => {
      const cards = [...list.querySelectorAll(':scope > product-card')];
      const sorted = [...cards].sort((a, b) => Number(a.dataset.colorRank) - Number(b.dataset.colorRank));
      if (cards.some((card, index) => card !== sorted[index])) {
        const fragment = document.createDocumentFragment();
        sorted.forEach(card => fragment.appendChild(card));
        list.appendChild(fragment);
      }
    });
  };

  sortCollectionColors(document);

  const collectionColorObserver = new MutationObserver(mutations => {
    if (mutations.some(mutation => [...mutation.addedNodes].some(node => node.nodeType === 1))) {
      sortCollectionColors(document);
    }
  });

  collectionColorObserver.observe(document.body, { childList: true, subtree: true });

  } catch(e) { console.error(e); }
})();
})();
